import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAssistantId } from 'chatspot-core/assistants/getAssistantId';
import { BREEZE_COPILOT, INTERACTIVE_MODE, SALES_COPILOT } from 'chatspot-core/types/CopilotAssistantTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const BREEZE_COPILOT_ASSISTANT = {
  type: BREEZE_COPILOT,
  name: 'Copilot',
  iconName: '',
  id: undefined,
  welcomeMessage: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "threads.emptyState.titleV2"
  })
};
export const INTERACTIVE_MODE_COPILOT_ASSISTANT = {
  type: INTERACTIVE_MODE,
  name: 'Interactive Mode',
  iconName: 'Interactive Mode',
  id: 2,
  welcomeMessage: 'Let me know how I can help!'
};
export const SALES_COPILOT_ASSISTANT = {
  type: SALES_COPILOT,
  name: 'Sales Copilot',
  iconName: 'Sales Copilot',
  id: getAssistantId(),
  welcomeMessage: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "threads.salesCopilotEmptyState.subheading"
  })
};